import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=60a2c561&scoped=true&lang=pug&"
import script from "./TextInput.vue?vue&type=script&lang=ts&"
export * from "./TextInput.vue?vue&type=script&lang=ts&"
import style0 from "./TextInput.vue?vue&type=style&index=0&id=60a2c561&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2c561",
  null
  
)

export default component.exports